import "bootstrap/dist/css/bootstrap.min.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import SmoothScrolling from "./common/elements/SmoothScrolling";
import GlobalContextProvider from "./contexts/GlobalContextProvider";
import "./index.css";
import router from "./routes";
import store from "./store.js";
import { CLIENT_ID, DOMAIN } from "./util/common_variable";
import { ConfigProvider, theme } from "antd";
import { ant as antCustomTheme } from "./util/ant_var";
import { ReportModalProvider } from "@/contexts/ReportModalContext";

// "from-jacket" / "jacket-before" / "createNewBooking" / "jacket-new-folder"
// are one-shot signals set by Folder Search ("the user just picked/created a
// folder — show the edit form on whichever page they land on") and read once
// by that landing page (Bookings, Warrants, VisitorLog, Users, Staffing,
// InmateMovement). They're never cleared after being read, only on
// logout — so sessionStorage keeps carrying them across a plain browser
// refresh, and refreshing e.g. /bookings directly re-triggers edit mode
// instead of showing that page's list, indefinitely, until logout.
//
// Clearing them here — before React even mounts, and only on an actual
// reload (not a fresh tab/session, not an in-app SPA navigation, which
// doesn't produce a new "navigation" entry at all) — fixes the stale
// refresh case without touching the flags' normal one-shot behavior when
// they're genuinely just been set by a Folder Search selection.
try {
  const navigationEntry = performance.getEntriesByType("navigation")[0];
  if (navigationEntry?.type === "reload") {
    sessionStorage.removeItem("from-jacket");
    sessionStorage.removeItem("jacket-before");
    sessionStorage.removeItem("createNewBooking");
    sessionStorage.removeItem("jacket-new-folder");
  }
} catch {
  // Navigation Timing API unavailable — leave sessionStorage as-is.
}

createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <ConfigProvider theme={antCustomTheme}>
    <Provider store={store}>
      {/* <SmoothScrolling> - This causes slow scrolling and blocks Ant component scrolling. */}
      <GlobalContextProvider>
        <ReportModalProvider>
          <RouterProvider router={router} />
        </ReportModalProvider>
      </GlobalContextProvider>
      {/* </SmoothScrolling> */}
    </Provider>
  </ConfigProvider>
  // </StrictMode>
);
